import { render, staticRenderFns } from "./TrashIcon.vue?vue&type=template&id=1be3f7be&scoped=true"
import script from "./TrashIcon.vue?vue&type=script&lang=js"
export * from "./TrashIcon.vue?vue&type=script&lang=js"
import style0 from "./TrashIcon.vue?vue&type=style&index=0&id=1be3f7be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be3f7be",
  null
  
)

export default component.exports